import React, { useCallback, useState } from "react";
import pxToRem from "libs/pxToRem";

import { DataCard, CardContainer } from "components/styled/dataCard/DataCard";
import DataCardRow from "components/styled/dataCard/DataCardRow";

import { SolicitudConsumoAnalisisResponse } from "api/types/originacion/services/analisisSolicitudTypes";
import { EEstadoSolicitudConsumo } from "api/types/originacion/businessTypes";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import FolderOpenOutlinedIcon from "@material-ui/icons/FolderOpenOutlined";
import { styled } from "@material-ui/core/styles";
import { useResumenCuotas } from "components/hooks/useResumenCuotas";
import TicketVentaModal from "./TicketVentaModal";

const DocumentacionAdjuntaCard: React.FC<{
  operacion?: SolicitudConsumoAnalisisResponse;
  isLoading?: boolean;
}> = ({ operacion, isLoading = false }) => {
  const [isTicketModalOpen, setIsTicketModalOpen] = useState(false);

  const operacionIsInValidState =
    operacion?.estado === EEstadoSolicitudConsumo.En_Analisis ||
    operacion?.estado === EEstadoSolicitudConsumo.Aprobada ||
    operacion?.estado === EEstadoSolicitudConsumo.Liquidada ||
    (operacion?.estado === EEstadoSolicitudConsumo.Desistida &&
      operacion?.fechaLiquidacion);

  const { isFetching: loadingResumenFetching, refetch: refetchResumen } =
    useResumenCuotas(operacion?.id || 0, false);

  const handleClickResumen = useCallback(async () => {
    const { data: resumenUrl, isSuccess } = await refetchResumen();
    if (isSuccess) {
      window.open(resumenUrl, "_blank", "noopener,noreferrer");
    }
  }, [refetchResumen]);

  if (!operacionIsInValidState) return null;

  return (
    <CardContainer>
      <DataCard
        title="DOCUMENTACIÓN ADJUNTA"
        icon={<FolderOpenOutlinedIcon style={{ color: "#9e9e9e" }} />}
      >
        <DataCardRow
          label="Ticket de venta"
          isLoading={isLoading}
          selectable
          value={
            <Typography>
              <StyledLink onClick={() => setIsTicketModalOpen(true)}>
                Ver ticket
              </StyledLink>
            </Typography>
          }
        />
        <DataCardRow
          label="Resumen de cuotas"
          isLoading={isLoading}
          selectable
          value={
            <Box style={{ textAlign: "right", maxHeight: pxToRem(25) }}>
              {loadingResumenFetching ? (
                <CircularProgress
                  size={20}
                  style={{
                    paddingBlock: "auto",
                    marginRight: pxToRem(30),
                    marginTop: pxToRem(5),
                  }}
                />
              ) : (
                <Typography>
                  <StyledLink onClick={handleClickResumen}>
                    Ver resumen
                  </StyledLink>
                </Typography>
              )}
            </Box>
          }
        />
      </DataCard>

      <TicketVentaModal
        solicitudId={operacion?.id}
        urlsTicketVenta={operacion?.urlsTicketVenta ?? []}
        open={isTicketModalOpen}
        onClose={() => setIsTicketModalOpen(false)}
      />
    </CardContainer>
  );
};

export default DocumentacionAdjuntaCard;

const StyledLink = styled(Link)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontWeight: 800,
  "&:focus, &:visited, &:link, &:active": {
    textDecoration: "none",
  },
  textDecoration: "underline",
  "&:hover": {
    cursor: "pointer",
  },
}));
